/* eslint-disable react-hooks/exhaustive-deps */
import moment from "moment";
import React, { useEffect, useState } from "react";
import FormLayout from "../../components/formlayout/formlayout";
import axiosInstance from "../../config/axios";
import TextInput from "../../components/form/inputs/text-input/text-input";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { showToast } from "../../utils/utils";
import SelectInput from "../../components/form/inputs/select-input/select-input";
import DateTimeInput from "../../components/form/inputs/datetime-input/date-time-input";
import AvoirModal from "../../components/avoirmodal/avoirmodal";
import { useAppContext } from "../../context/app.context";
import { Link } from "react-router-dom";

const AVOIR_ELIGIBLE = ["commission", "ft", "fac", "annulation", "rémunération", "fvj"];

export default function EditAddFacturePage() {
  const [loading, setIsLoading] = useState(false);
  const [notFound, setnotFound] = useState(false);
  const { id } = useParams();
  const location = useLocation();
  const isAdd = location.pathname?.endsWith("add") ? true : false;
  const [data, setdata]: any = useState({});
  const [jobbeur, setjobbeur] = useState([]);
  const [entreprises, setentreprises] = useState([]);
  const [type, settype] = useState("commission");
  const [avoirModal, setAvoirModal] = useState(false);
  const [avoirs, setAvoirs] = useState<any[]>([]);
  const [remainingHT, setRemainingHT] = useState<number | null>(null);
  const { appInfos } = useAppContext();
  const isAdminPrums = appInfos.user?.type === "Admin";
  const navigate = useNavigate();
  const isFvj = type === "fvj";
  const canGenerateAvoir = !isAdd && isAdminPrums && AVOIR_ELIGIBLE.includes(data?.type);

  function computeRemaining(facture: any, avoirsList: any[]) {
    const credited = avoirsList.reduce((sum, a) => sum + +(a.priceHT || 0), 0);
    return +(+(facture?.priceHT || 0) - credited).toFixed(2);
  }
  async function onSubmit(form: any) {
    try {
      if (!isAdd) {
        return showToast("Une facture émise est inaltérable. Utilisez un avoir pour corriger.");
      }
      if (isNaN(form.tvapercent) || form.tvapercent > 100 || form.tvapercent < 0)
        return showToast("Pourcentage TVA invalide");
      if (!form.idJobbeur) form.idJobbeur = undefined;
      if (isFvj) {
        form.type = "fvj";
        form.description = form.description || "Valorisation Jobber";
        form.tvapercent = form.tvapercent ?? "0";
        delete form.idEntreprise;
      }
      await axiosInstance.post("factures", form);
      showToast("Ajout avec succés", "success");
      navigate(-1);
    } catch (e: any) {
      showToast(e?.response?.data?.message || "Erreur lors de la création");
    }
  }

  async function getData() {
    setIsLoading(true);
    try {
      const jobbeurData = (await axiosInstance.get("/users/select/jobbeur")).data;
      setjobbeur(jobbeurData.data);
      const entrepriseData = (await axiosInstance.get("/users/select/entreprise")).data;
      setentreprises(entrepriseData.data);
      if (!isAdd) {
        const { data } = await axiosInstance.get("factures" + "/" + id);
        settype(data.data.type);
        setdata(data.data);
        try {
          const avoirsRes = await axiosInstance.get("avoirs/facture/" + id);
          const avoirsList = avoirsRes.data || [];
          setAvoirs(avoirsList);
          setRemainingHT(computeRemaining(data.data, avoirsList));
        } catch (e) {
          setRemainingHT(computeRemaining(data.data, []));
        }
      }
    } catch (e: any) {
      if (e.response?.status == 404) setnotFound(true);
    }
    setIsLoading(false);
  }

  useEffect(() => {
    getData();
  }, [isAdd]);
  return (
    <>
      <FormLayout
        permission={"factures"}
        title="facture"
        img=""
        onSubmit={onSubmit}
        loading={loading}
        notFound={notFound}
        isAdd={isAdd}
        hideSubmit={!isAdd}
        secondtitle={canGenerateAvoir ? "Générer un avoir" : undefined}
        onSubmitSecond={canGenerateAvoir ? () => setAvoirModal(true) : undefined}
        secondDisabled={remainingHT === null || remainingHT <= 0}
      >
        <div className="row" style={{ display: "flex", flexGrow: 1 }}>
          <div className="col-sm-12 col-md-12 ">
            <SelectInput
              options={[
                { label: "commission", value: "commission" },
                { label: "rémunération", value: "rémunération" },
                { label: "FVJ – Valorisation Jobber", value: "fvj" },
              ]}
              onChange={(val: any) => settype(val.value)}
              disabled={!isAdd}
              value={data?.type || type}
              name="type"
              label="Type facture"
            />
          </div>
          {!isAdd && (
            <div className="col-sm-12 col-md-12 ">
              <TextInput value={data.numFacture} disabled={true} label="Numéro de facture" />
            </div>
          )}
          <div className="col-sm-12 col-md-6 ">
            <DateTimeInput
              value={data.facturationDate || new Date()}
              required="Date de facturation invalide"
              name="facturationDate"
              label="Date de facturation"
              disabled={!isAdd}
            />
          </div>
          <div className="col-sm-12 col-md-6 ">
            <TextInput
              value={
                data.description ||
                (isFvj
                  ? "Valorisation Jobber"
                  : type == "commission"
                  ? "Recherche et mise en relation avec un prestataire"
                  : "Prestation de service")
              }
              required="description invalide"
              name="description"
              label="Description"
              disabled={!isAdd}
            />
          </div>
          <div className="col-sm-12 col-md-12 ">
            <TextInput
              type="number"
              value={data.priceHT}
              required="Prix hors taxe invalide"
              name="priceHT"
              label="Prix hors taxe"
              disabled={!isAdd}
            />
          </div>
          <div className="col-sm-12 col-md-12 ">
            <TextInput
              type="text"
              value={
                data.tvapercent != undefined
                  ? data.tvapercent + ""
                  : type == "commission"
                  ? "20"
                  : "0"
              }
              required="Pourcentage TVA invalide"
              name="tvapercent"
              label="Pourcentage TVA"
              min={0}
              max={100}
              disabled={!isAdd}
            />
          </div>
          {(type != "commission" || isFvj) && (
            <div className="col-sm-12 col-md-12 ">
              <SelectInput
                options={jobbeur?.map((elt: any) => ({
                  label: elt.prenom + " " + elt.nom,
                  value: elt._id,
                }))}
                value={data.idJobbeur?._id}
                disabled={!isAdd}
                required={isAdd ? "Sélectionner un jobbeur" : false}
                name="idJobbeur"
                label="Jobbeur"
              />
            </div>
          )}
          {!isFvj && (
            <div className="col-sm-12 col-md-12 ">
              <SelectInput
                disabled={!isAdd}
                options={entreprises?.map((elt: any) => ({
                  label: elt.NomEntreprise,
                  value: elt._id,
                }))}
                value={data.idEntreprise?._id}
                required={isAdd ? "Sélectionner une entreprise" : false}
                name="idEntreprise"
                label="Entreprise"
              />
            </div>
          )}
          {isFvj && isAdd && (
            <div className="col-sm-12">
              <p style={{ fontSize: 13, color: "#666" }}>
                Destinataire : <strong>SAS ARÈS</strong> — Numérotation automatique FVJ-000001…
              </p>
            </div>
          )}
        </div>

        {!isAdd && (avoirs.length > 0 || remainingHT !== null) && (
          <div style={{ marginTop: 32, paddingTop: 24, borderTop: "1px solid #eee" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 16,
              }}
            >
              <h5 style={{ margin: 0, fontWeight: 600, fontSize: 16 }}>
                Avoirs liés {avoirs.length > 0 && <span className="badge badge-blue">{avoirs.length}</span>}
              </h5>
              {remainingHT !== null && (
                <span style={{ fontSize: 13, color: remainingHT > 0 ? "#2e7d32" : "#888" }}>
                  Restant créditable : <strong>{remainingHT.toFixed(2)} € HT</strong>
                </span>
              )}
            </div>

            {avoirs.length > 0 ? (
              <div style={{ overflowX: "auto", borderRadius: 8, border: "1px solid #eee" }}>
                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
                  <thead>
                    <tr style={{ background: "#fafafa", textAlign: "left" }}>
                      <th style={{ padding: "10px 12px", fontWeight: 600 }}>Type</th>
                      <th style={{ padding: "10px 12px", fontWeight: 600 }}>N° avoir</th>
                      <th style={{ padding: "10px 12px", fontWeight: 600 }}>Date</th>
                      <th style={{ padding: "10px 12px", fontWeight: 600 }}>Montant HT</th>
                      <th style={{ padding: "10px 12px", fontWeight: 600 }}>Montant TTC</th>
                      <th style={{ padding: "10px 12px", fontWeight: 600 }}>Motif</th>
                      <th style={{ padding: "10px 12px", fontWeight: 600, width: 60 }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {avoirs.map((a: any, i: number) => (
                      <tr
                        key={a._id}
                        style={{ borderTop: "1px solid #eee", background: i % 2 ? "#fff" : "#fcfcfc" }}
                      >
                        <td style={{ padding: "10px 12px" }}>{a.avoirKind || "AV"}</td>
                        <td style={{ padding: "10px 12px", fontWeight: 500 }}>{a.numAvoir}</td>
                        <td style={{ padding: "10px 12px" }}>{moment(a.created_at).format("DD/MM/YYYY")}</td>
                        <td style={{ padding: "10px 12px" }}>{(+a.priceHT).toFixed(2)} €</td>
                        <td style={{ padding: "10px 12px" }}>{(+a.priceTTC).toFixed(2)} €</td>
                        <td style={{ padding: "10px 12px", color: "#555", maxWidth: 220 }}>{a.motif}</td>
                        <td style={{ padding: "10px 12px" }}>
                          <a
                            href={
                              process.env.REACT_APP_SERVER_URL +
                              "/api/avoirs/avoirpdf/" +
                              a._id +
                              "?token=" +
                              appInfos.token
                            }
                            target="_blank"
                            rel="noreferrer"
                            title="Télécharger le PDF"
                          >
                            <img width={18} src="/images/download.svg" alt="PDF" />
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p style={{ fontSize: 13, color: "#888", margin: 0 }}>Aucun avoir émis pour cette facture.</p>
            )}

            <Link to="/avoirs" style={{ display: "inline-block", marginTop: 12, fontSize: 13 }}>
              Voir tous les avoirs →
            </Link>
          </div>
        )}
      </FormLayout>
      {!isAdd && (
        <AvoirModal
          show={avoirModal}
          facture={data}
          onClose={() => setAvoirModal(false)}
          onSuccess={getData}
        />
      )}
    </>
  );
}
